module.exports = __webpack_public_path__ + "img/a7.f41f8d9e.jpg";